// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fd4b7ff5","455":"e5e1ecad"}[chunkId] + ".chunk.js";
};